var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showDetail,
              expression: "!showDetail"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMainList,
                  expression: "showMainList"
                }
              ],
              staticClass: "main-content",
              staticStyle: {
                height: "100%",
                display: "flex",
                "flex-direction": "column"
              },
              attrs: { type: "primary" }
            },
            [
              _c(
                "search-item",
                {
                  attrs: { "config-module": "600", reset: true, no: "1" },
                  on: {
                    "click-more": function(value) {
                      return (_vm.isAdvancedQuery = value)
                    },
                    simSearchItemCallBack: _vm.toSimpleQuery,
                    advSearchItemCallBack: _vm.toAdvancedQuery
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", no: "2" },
                          on: {
                            click: function($event) {
                              return _vm.toLook()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "3" },
                          on: {
                            click: function($event) {
                              return _vm.toEdit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ProjectModule_delete"],
                              expression: "['button_ProjectModule_delete']"
                            }
                          ],
                          attrs: { type: "danger", no: "4" },
                          on: {
                            click: function($event) {
                              return _vm.toBatchDelete()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", no: "5" },
                          on: {
                            click: function($event) {
                              return _vm.toAdd()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "6" },
                          on: {
                            click: function($event) {
                              return _vm.toExportToExcel()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.exportExcel")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.yuhaiApiIsEdit,
                            no: "7"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toCloseProject()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Project.CloseProject")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.yuhaiApiIsEdit,
                            no: "8"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toOpenProject()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Project.RebuildProject")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { flex: "1", width: "100%", height: "100%" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "grid-params": _vm.gridParams,
                      no: "9"
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: function(params) {
                        return (_vm.gridApi = params.api)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.filter.total > 0,
                        expression: "filter.total>0"
                      }
                    ],
                    attrs: {
                      total: _vm.filter.total,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize,
                      no: "10"
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: _vm.toQuery
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.showDetail
        ? _c("project-detail", {
            ref: "projectDetail",
            attrs: {
              "row-uuid": _vm.rowUuid,
              op: _vm.op,
              "view-source": _vm.detailViewSource,
              no: "11"
            },
            on: { backList: _vm.toBackPreView }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }